import { render, staticRenderFns } from "./Basis.vue?vue&type=template&id=d3bbb706&scoped=true&"
import script from "./Basis.vue?vue&type=script&lang=ts&"
export * from "./Basis.vue?vue&type=script&lang=ts&"
import style0 from "./Basis.vue?vue&type=style&index=0&id=d3bbb706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bbb706",
  null
  
)

export default component.exports